/**
 * Row — label / value row inside a SectionCard. First row has no top border.
 */
import type { ReactNode } from "react";

interface RowProps {
  label: string;
  children: ReactNode;
  first?: boolean;
  className?: string;
}

export const Row = ({ label, children, first, className }: RowProps) => {
  return (
    <div
      className={`flex items-center justify-between py-3 ${first ? "" : "border-t border-[#F3F4F6]"} ${className ?? ""}`}
    >
      <span className="text-sm text-gray-500">{label}</span>
      {children}
    </div>
  );
};

export default Row;
